import axios from "@/components/api/axios";

const list = request => {
    return axios.post(
        '/kkt/list',
        request).then(response => response.data)
}

const get = request => {
    return axios.post(
        '/kkt/get',
        request).then(response => response.data)
}

const add = request => {
    return axios.post(
        '/kkt',
        request).then(response => response.data)
}

const upd = request => {
    return axios.put(
        '/kkt',
        request).then(response => response.data)
}

export default {
    get,
    list,
    add,
    upd
}